import React from 'react';

import Project from './project';

import SideBar from './ui/side-bar.jsx';
import StatusBar from './ui/status-bar.jsx';

const { $ } = window;

// Это вообще неправильно - использовать react только тут, и вообще
// Но эта фигня нужна только для UI, и поэтому оно слабо связано,
// и главный код на самом деле в ./project.js
// Короче, хрень какая-то получилась, но работает и удобно

export default class LatorApp extends React.Component {
  constructor() {
    super();
    this.state = {
      project: null
    };
  }

  componentDidMount() {
    let project = new Project(this);
    this.setState({
      project: project
    });

    $('[data-content]').popup();
  }

  render() {
    let project = this.state.project;
    let viewport = project ? project.viewport : null;

    return (
      <div id="app">
        <div id="workspace">
          <canvas id="viewport" crossOrigin="Anonymous" />
        </div>
        {project &&
          <SideBar project={project} />
        }
        {viewport &&
          <StatusBar project={project} viewport={viewport} />
        }
      </div>
    );
  }
}
